import React, { useState, useEffect } from "react";
import "./Header.css";
import serverConfig from "./config";

const TypingEffect = ({ text, speed }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[currentIndex]);
        setCurrentIndex(currentIndex + 1);
      }, speed);
      return () => clearTimeout(timeout);
    } else {
      const cursorTimeout = setTimeout(() => {
        setShowCursor(false);
      }, 2000);
      return () => clearTimeout(cursorTimeout);
    }
  }, [currentIndex, text, speed]);

  return (
    <div
      style={{
        backgroundColor: "#003366",
        border: "2px solid #FAFAFA",
        borderRadius: "10px",
        marginTop: "5px",
        color: "#FAFAFA",
        display: "flex",
        justifyContent: "center",
        padding: "10px",
        textAlign: "center",
      }}
    >
      <p style={{ width: "75%" }}>
        {displayedText}
        {showCursor && <span className="blinking-cursor">|</span>}
      </p>
    </div>
  );
};

{/*
const ImageLayout = (
  <div className="row">
    <div className="col-2">
      <img
        src={`${serverConfig.serverUrl}/img/sfondo_home/Originale.png`}
        alt="SOC"
        className="corner-image"
      />
    </div>

    <div className="col-8">
      <img
        src={`${serverConfig.serverUrl}/img/sfondo_home/sdm.png`}
        alt="Consiglio direttivo sdm"
        className="corner-image"
      />
    </div>

    <div className="col-2">
      <img
        src={`${serverConfig.serverUrl}/img/sfondo_home/imss-logo-400.jpg`}
        alt="imss"
        className="corner-image"
      />
    </div>
  </div>
);
*/}

const Header = () => {
  const text = '"La Divisione ha lo scopo di riunire i cultori della Spettrometria di Massa, favorendo la diffusione ed il potenziamento degli aspetti scientifici, tecnologici e didattici di tale disciplina mediante pubblicazioni, congressi, corsi di aggiornamento, gruppi di studio e altre iniziative, anche in collegamento con altri Enti operanti nello stesso settore o in settori affini"';

  return (
    <>
      <div style={{ height: "auto", color: "#123456" }}>
        <div style={{ position: "relative", width: "100%" }}>
          {/*{ImageLayout}*/}
          <TypingEffect text={text} speed={20} />
        </div>
      </div>
    </>
  );
};

export default Header;
